var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcMessageDarkblue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.87868 5.10085C2 5.97953 2 7.39374 2 10.2222V13.7777C2 16.6062 2 18.0204 2.87868 18.899C3.75736 19.7777 5.17157 19.7777 8 19.7777H16C18.8284 19.7777 20.2426 19.7777 21.1213 18.899C22 18.0204 22 16.6061 22 13.7777V10.2222C22 7.39374 22 5.97953 21.1213 5.10085C20.2426 4.22217 18.8284 4.22217 16 4.22217H8C5.17157 4.22217 3.75736 4.22217 2.87868 5.10085ZM5.88803 7.83456C5.4285 7.52821 4.80764 7.65238 4.50128 8.11191C4.19493 8.57144 4.3191 9.19231 4.77863 9.49866L10.8906 13.5733C11.5624 14.0212 12.4376 14.0212 13.1094 13.5733L19.2214 9.49866C19.6809 9.19231 19.8051 8.57144 19.4987 8.11191C19.1924 7.65238 18.5715 7.52821 18.112 7.83456L12 11.9092L5.88803 7.83456Z",
    fill: "#172B4D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcMessageDarkblue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-message-darkblue.4ce1c0f76b1f79df9188ac5edcd7f9a1.svg";